<template>
  <div class="share">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="card total">
        <div class="total-item">
          <span class="num">{{ total || '-' }}</span>
          <span class="desc">订单数(笔)</span>
        </div>
        <div class="total-item">
          <span class="num">{{ sum || '-' }}</span>
          <span class="desc">预计收益(元)</span>
        </div>
      </div>
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="card list">
          <div class="list-item" v-for="item in list" :key="item">
            <div class="info">
              <div class="plazName">{{ item.weChatDisplayName }}</div>
              <div class="time">
                成单时间：{{ item.orderTime | formatTime }}
              </div>
            </div>
            <div class="money">
              <span class="num">+{{item.shareReward | formatShareReward}}</span>
              <span>元</span>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { ApiGetShareDetail } from '@/api/insurance.js';
import { List, PullRefresh } from 'vant';
import moment from 'moment';
export default {
  data() {
    return {
      list: [],
      refreshing: false,

      loading: false,
      finished: false,
      pageNum: 0,
      pageSize: 20,
      total: 0,
      sum:0
    };
  },
  filters: {
    formatTime(value) {
      return moment(value).format('YYYY-MM-DD hh:mm:ss');
    },
    formatShareReward(value) {
      return value ? (value / 100).toFixed(2) : 0
    }
  },
  components: {
    VanList: List,
    VanPullRefresh: PullRefresh,
  },
  computed: {
    userId() {
      return this.$store.state.account.userId;
    },
    userIdToken() {
      return this.$route.query.userIdToken;
    },
  },
  methods: {
    onRefresh() {
      this.refreshing = true;
      this.pageNum = 1;
      this.list = [];
      this.getList();
    },
    onLoad() {
      console.log('onLoad');
      this.pageNum++;
      this.getList();
    },
    getList() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        userId: this.userIdToken,
      };
      ApiGetShareDetail(data, this.userIdToken).then((res) => {
        let items = res.items;
        this.total = res.totalCount;
        this.sum = (res.sum/100).toFixed(2)
        // this.total = 35;
        // let items = [];
        // for (let index = 0; index < 20; index++) {
        //   items.push({
        //     weChatDisplayName: '万达广场' + this.pageNum + index,
        //     orderTime: new Date(),
        //   });
        // }
        this.list = this.list.concat(items);
        this.refreshing = false;
        this.loading = false;

        this.finished = false;
        if (this.pageNum * 20 >= this.total) {
          this.finished = true;
        }
      });
    },
  },
  mounted() {
    // this.getList();
  },
};
</script>

<style lang="less" scoped>
.share {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #111111;
  line-height: 1;
  text-align: left;
  background: #f3f5f6;
  overflow: auto;
  padding: 12px;
  box-sizing: border-box;

  .card {
    background: #ffffff;
    border-radius: 8px;
  }

  .total {
    display: flex;
    padding: 20px 0;

    .total-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      text-align: center;

      .num {
        font-size: 28px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #111111;
        line-height: 33px;
      }

      .desc {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
      }
    }
  }

  .list {
    padding: 12px;
    margin-top: 12px;

    .list-item {
      display: flex;
      align-items: center;
      padding: 12px 0;
      border-bottom: 1px dashed rgba(240, 240, 240, 0.8);

      .info {
        flex: 1;

        .plazName {
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #111111;
          line-height: 23px;
        }

        .time {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 16px;
        }
      }

      .money {
        font-size: 12px;

        .num {
          font-size: 20px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #ff1d1d;
          line-height: 24px;
        }
      }
    }
  }
}

/deep/.van-pull-refresh__track {
  min-height: 400px;
}</style>